<script lang="ts">
  import { useDynamicConfig } from '@/ui/state/use-core-state.svelte';

  import DebugComponent from './DebugComponent.svelte';

  const dynamicConfig = useDynamicConfig();

  let visible = $state(false);
</script>

{#if $dynamicConfig.debugPermissions}
  <!-- stacks over the app, but below the dialogs; only the button and the panel take clicks -->
  <div class="pointer-events-none fixed right-0 top-0 z-[60] h-full w-0">
    <div
      class="h-full transition-transform
{visible ? 'w-[330px] translate-x-[-330px]' : 'w-[30px] translate-x-[-30px] overflow-hidden'}"
    >
      <button
        class="pointer-events-auto absolute left-[-9px] top-[80px] inline-block -rotate-90 bg-tooltip-S p-1"
        onclick={() => (visible = !visible)}
      >
        Debug</button
      >
      <div class="pointer-events-auto ml-[30px] h-full overflow-auto bg-tooltip-S p-2">
        <DebugComponent />
      </div>
    </div>
  </div>
{/if}
